<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 4.25C1 4.25 2.09091 2 4 2C5.90909 2 7 4.25 7 4.25C7 4.25 5.90909 6.5 4 6.5C2.09091 6.5 1 4.25 1 4.25Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.818 4.25C4.818 4.71599 4.45169 5.09375 3.99982 5.09375C3.54795 5.09375 3.18164 4.71599 3.18164 4.25C3.18164 3.78401 3.54795 3.40625 3.99982 3.40625C4.45169 3.40625 4.818 3.78401 4.818 4.25Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
